module.exports = __webpack_public_path__ + "img/karamoja2.63f97e4d.jpg";